// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Lookup center'"></sub-header>

  <!-- lookup center form -->
  <form class="filters" name="form">
    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_name">Name</label>
      <input ng-model="\$ctrl.params.name" id="dlc_name" type="text" autocomplete="off">
    </div>
    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_reference_no">Reference no.</label>
      <input ng-model="\$ctrl.params.referenceNumber" id="dlc_reference_no" type="text" autocomplete="off">
    </div>
    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_loan_officer_name">Loan officer</label>
      <input ng-model="\$ctrl.params.loanOfficerName" id="dlc_loan_officer_name" type="text" autocomplete="off">
    </div>
    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_loan_collector_name">Loan collector</label>
      <input ng-model="\$ctrl.params.loanCollectorName" id="dlc_loan_collector_name" type="text" autocomplete="off">
    </div>
    <div class="labelled-field labelled-field--short">
      <label class="control-label" for="dlc_branch_id">Branch</label>
      <multiselect id="dlc_branch_id"
                   class="no-prefix-input"
                   items="\$ctrl.branches"
                   label-property="'name'"
                   value-property="'id'"
                   ng-model="\$ctrl.params.branchIds"
                   select-all-option="true"
                   ng-required="true">
      </multiselect>
    </div>

    <button class="btn btn-primary search-button" ng-click="\$ctrl.search()" ng-disabled="!\$ctrl.enableSearch()">
      Search
    </button>
    <button
      ng-disabled="!\$ctrl.enableNewCenterButton()"
      class="btn btn-disabled search-button"
      ng-class="{'btn-primary': \$ctrl.enableNewCenterButton()}"
      ng-click="\$ctrl.createCenter()"
      command-access="CreateCenter">
      New center
    </button>
  </form>

  <div class="empty-message" ng-if="!\$ctrl.searchPerformed">
    <span>Please enter search criteria to lookup center</span>
  </div>

  <div class="empty-message" ng-if="\$ctrl.emptyResults()">
    <span>No centers matching the given criteria exist</span>
  </div>

  <table ng-show="\$ctrl.showResults()" class="table" ng-table="\$ctrl.tableConfig">
    <tr ng-repeat="result in \$data">
      <td data-title="'No.'">{{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}</td>
      <td data-title="'Name'">{{result.name}}</td>
      <td data-title="'Reference no.'">{{result.id}}</td>
      <td data-title="'Branch'">{{\$ctrl.branchNames[result.branchId]}}</td>
      <td data-title="'Loan officer'">{{\$ctrl.users[result.loanOfficerId].effectiveName}}</td>
      <td data-title="'Loan collector'">{{\$ctrl.users[result.loanCollectorId].effectiveName}}</td>
      <td data-title="'Status'">{{result.active ? 'Active' : 'Inactive'}}</td>

      <td>
        <button type="button" ng-click="\$ctrl.openCenter(result)" class="btn btn-primary">
          Open
        </button>
      </td>
    </tr>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/lookup-center/lookup-center.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;